// src/pages/auth/RegisterPage.js

import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import RegisterForm from '../../components/forms/RegisterForm';
import NetworkBackground from '../../components/NetworkBackground';
import authService from '../../services/authService';
import styles from './RegisterPage.module.css';

export default function RegisterPage() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleRegister = async (credentials) => {
    const result = await authService.register(credentials);
    if (result.success) {
      setMessage('Account created. Check your email to verify before logging in.');
      setError('');
      setTimeout(() => navigate('/login'), 3000); // optional auto-redirect
    } else {
      setError(result.error || 'Registration failed. Please try again.');
      setMessage('');
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <NetworkBackground />
      <div className={styles.card}>
        <RegisterForm onRegister={handleRegister} />

        {message && <p className={styles.success}>{message}</p>}
        {error && <p className={styles.error}>{error}</p>}

        <div className={styles.footerText}>
          Already have an account? <Link to="/login">Login</Link>
        </div>
      </div>
    </div>
  );
}
